"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_redux_1 = require("react-redux");
const roomCreateStore_1 = require("@/room/room_create/roomCreateStore");
const react_hook_form_1 = require("react-hook-form");
const react_i18next_1 = require("react-i18next");
const svgs_1 = require("@@/assets/svgs");
const FormControlLabel_1 = __importDefault(require("@mui/material/FormControlLabel"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const Checkbox_1 = __importDefault(require("@mui/material/Checkbox"));
const styled_1 = __importDefault(require("@emotion/styled"));
function default_1({ questionData, index, control, errors, }) {
    var _a;
    const { t } = (0, react_i18next_1.useTranslation)();
    const { field: { onChange: onQuestionChange }, } = (0, react_hook_form_1.useController)({
        name: `question_${index}`,
        control,
        rules: {
            required: true,
            pattern: { value: /^[^,]+$/, message: `${t('콤마 (,)를 제거해주세요')}.` },
        },
        defaultValue: questionData.content,
    });
    const questionsLength = (0, react_redux_1.useSelector)((state) => state.roomData.questions.length);
    const dispatch = (0, react_redux_1.useDispatch)();
    const additionQuestion = (content, index) => {
        dispatch((0, roomCreateStore_1.modifyAdditionQuestion)({ content, index }));
    };
    const additionImageCheck = (is_image, index) => {
        dispatch((0, roomCreateStore_1.modifyAdditionImageCheck)({ is_image, index }));
    };
    const additionRequiredCheck = (is_required, index) => {
        dispatch((0, roomCreateStore_1.modifyAdditionRequiredCheck)({ is_required, index }));
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(AdditionQuestionWrapper, { children: [(0, jsx_runtime_1.jsx)("input", { defaultValue: questionData.content, maxLength: 256, placeholder: t('질문을 작성해주세요'), name: `question_${index}`, onBlur: e => {
                            const value = e.target.value.replace(/,/g, '').replace(/\\x08/g, '');
                            additionQuestion(value, index);
                        }, onChange: e => {
                            onQuestionChange(e.target.value);
                        }, autoComplete: "off" }), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "image_check_wrapper" }, { children: [(0, jsx_runtime_1.jsx)(FormControlLabel_1.default, { labelPlacement: "end", className: "check_container", control: (0, jsx_runtime_1.jsx)(Checkbox_1.default, { checked: questionData.is_required, onChange: () => additionRequiredCheck(questionData.is_required, index) }), label: (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "label_container" }, { children: t('필수 수집') })) }), (0, jsx_runtime_1.jsx)(FormControlLabel_1.default, { labelPlacement: "end", className: "check_container", control: (0, jsx_runtime_1.jsx)(Checkbox_1.default, { checked: questionData.is_image, onChange: () => additionImageCheck(questionData.is_image, index) }), label: (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "label_container" }, { children: t('이미지 첨부 받기') })) })] })), questionsLength > 1 && ((0, jsx_runtime_1.jsx)(IconButton_1.default, Object.assign({ className: "delete_question", onClick: () => {
                            dispatch((0, roomCreateStore_1.deleteAdditionQuestion)(index));
                        } }, { children: (0, jsx_runtime_1.jsx)(svgs_1.XCircleGraySvg, { css: {
                                width: '16px',
                                height: '16px',
                                borderRadius: '50%',
                                backdropFilter: 'blur(10px)',
                            } }) })))] }), ((_a = errors[`question_${index}`]) === null || _a === void 0 ? void 0 : _a.type) === 'pattern' && ((0, jsx_runtime_1.jsx)(ErrorWrapper, { children: errors[`question_${index}`].message }))] }));
}
exports.default = default_1;
const AdditionQuestionWrapper = styled_1.default.div `
  position: relative;
  display: flex;
  height: 66px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  flex-direction: column;
  input {
    height: 40px;
    border: 0 !important;
    border-radius: 6px 6px 0px 0px;
    margin: 0px 3px 0px 16px;
    font-size: 14px;
  }
  .image_check_wrapper {
    display: inline-flex;
    height: 24px;
    border-radius: 0px 0px 6px 6px;
    font-size: 14px;
    background: #f8f8f8;
    .check_container {
      height: 24px;
      column-gap: 0;
      .MuiCheckbox-root {
        padding: 4px;
      }
      .label_container {
        margin-right: 18px;
        font-size: 13px;
      }
    }
  }
  .delete_question {
    position: absolute;
    top: -9.5px;
    right: -8.5px;
  }
`;
const ErrorWrapper = styled_1.default.div `
  color: red;
  text-align: right;
  font-size: 12px;
  font-weight: normal;
  margin: -3px 0 3px;
`;
